import { GET_ALL_BOT_FORUM_STATS_FAIL, GET_ALL_BOT_FORUM_STATS_REQUEST, GET_ALL_BOT_FORUM_STATS_SUCCESS, GET_ALL_DATA_FAIL, GET_ALL_DATA_REQUEST, GET_ALL_DATA_SUCCESS, GET_ALL_USER_FORUM_STATS_REQUEST, GET_ALL_USERS_FAIL, GET_ALL_USERS_FORUM_STATS_FAIL, GET_ALL_USERS_FORUM_STATS_SUCCESS, GET_ALL_USERS_REQUEST, GET_ALL_USERS_SUCCESS, GET_BLINDBOX_LIST_FAIL, GET_BLINDBOX_LIST_REQUEST, GET_BLINDBOX_LIST_SUCCESS, GET_BOT_FAIL, GET_BOT_REQUEST, GET_BOT_SUCCESS, GET_CERTIFICATES_LIST_FAIL, GET_CERTIFICATES_LIST_REQUEST, GET_CERTIFICATES_LIST_SUCCESS, GET_FILENAMES_FAIL, GET_FILENAMES_IUIU_FAIL, GET_FILENAMES_IUIU_REQUEST, GET_FILENAMES_IUIU_SUCCESS, GET_FILENAMES_REQUEST, GET_FILENAMES_SUCCESS, GET_MCQ_LIST_FAIL, GET_MCQ_LIST_REQUEST, GET_MCQ_LIST_SUCCESS } from "../constants/allData";
import Certificate from "../pages/Certificate";


export const userReducer = (state = {loading: true, stat: {}}, action) =>{
    switch(action.type){
        case GET_ALL_USERS_REQUEST: 
            return {loading: true};
        case GET_ALL_USERS_SUCCESS:
            return {loading: false, user: action.payload};
        case GET_ALL_USERS_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
}

export const userForumStatReducer = (state = {loading: true, stat: {}}, action) =>{
    switch(action.type){
        case GET_ALL_USER_FORUM_STATS_REQUEST: 
            return {loading: true};
        case GET_ALL_USERS_FORUM_STATS_SUCCESS:
            return {loading: false, userForumStat: action.payload};
        case GET_ALL_USERS_FORUM_STATS_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
}

export const botReducer = (state = {loading: true, stat: {}}, action) =>{
    switch(action.type){
        case GET_BOT_REQUEST: 
            return {loading: true};
        case GET_BOT_SUCCESS:
            return {loading: false, bot: action.payload};
        case GET_BOT_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
}

export const botForumStatReducer = (state = {loading: true, stat: {}}, action) =>{
    switch(action.type){
        case GET_ALL_BOT_FORUM_STATS_REQUEST: 
            return {loading: true};
        case GET_ALL_BOT_FORUM_STATS_SUCCESS:
            return {loading: false, botForumStat: action.payload};
        case GET_ALL_BOT_FORUM_STATS_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
}

export const filenamesReducer = (state = {loading: true, stat: {}}, action) =>{
    switch(action.type){
        case GET_FILENAMES_REQUEST: 
            return {loading: true};
        case GET_FILENAMES_SUCCESS:
            return {loading: false, filenames: action.payload};
        case GET_FILENAMES_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
}

export const filenamesIuiuReducer = (state = {loading: true, stat: {}}, action) =>{
    switch(action.type){
        case GET_FILENAMES_IUIU_REQUEST: 
            return {loading: true};
        case GET_FILENAMES_IUIU_SUCCESS:
            return {loading: false, filenamesIuiu: action.payload};
        case GET_FILENAMES_IUIU_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
}

export const certificateListReducer = (state = {loading: true, stat: {}}, action) =>{
    switch(action.type){
        case GET_CERTIFICATES_LIST_REQUEST: 
            return {loading: true};
        case GET_CERTIFICATES_LIST_SUCCESS:
            return {loading: false, certificateList: action.payload};
        case GET_CERTIFICATES_LIST_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
}

export const blindboxListReducer = (state = {loading: true, stat: {}}, action) =>{
    switch(action.type){
        case GET_BLINDBOX_LIST_REQUEST: 
            return {loading: true};
        case GET_BLINDBOX_LIST_SUCCESS:
            return {loading: false, blindboxList: action.payload};
        case GET_BLINDBOX_LIST_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
}

export const MCQListReducer = (state = {loading: true, stat: {}}, action) =>{
    switch(action.type){
        case GET_MCQ_LIST_REQUEST: 
            return {loading: true};
        case GET_MCQ_LIST_SUCCESS:
            return {loading: false, MCQList: action.payload};
        case GET_MCQ_LIST_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
}